import { Table } from 'antd';
import { ITEMS_PER_PAGE, PAGE_SIZE, PAGE_SIZE_REPORT_SCHEDULE, ITEMS_PER_PAGE_REPORT_SCHEDULE } from 'app/shared/util/pagination.constants';
import React from 'react';

type ITableProps = {
  data: any[];
  columns: any[];
  handlePageChange?: (page: number, limit: number, filters?: any, sorter?: any) => void;
  isFetching: boolean;
  total?: number;
  setExpandedRowKeys?: (key: any) => void;
  noPagination?: boolean;
  noBordered?: boolean;
  expandedRowKeys?: any;
  scroll?: boolean;
  expandIconColumnIndex?: number;
  tableLayout?: any;
  handleRightClick?: (event: any, record: any, index: number) => void;
  handleRowClick?: (event: any, record: any,) => void;
  rowSelection?: any,
  positionPagination?: any[]
  components?: any
  perPageOptions?: any,
  pageSizeOptions?: any[]
};

const TableComponent = (props: ITableProps) => {
  return (
    <Table
      rowSelection={props.rowSelection}
      loading={props.isFetching}
      bordered={!props.noBordered}
      columns={props.columns}
      dataSource={props.data}
      locale={{ emptyText: 'Không có dữ liệu' }}
      expandable={{
        expandedRowKeys: props.expandedRowKeys,
        onExpandedRowsChange(newExpandedRowKeys) {
          props.setExpandedRowKeys(newExpandedRowKeys);
        },
        expandIconColumnIndex: props.expandIconColumnIndex, // di chuyển expand icon
      }}
      onRow={(record, index) => {
        return {
          onContextMenu: (event) => props.handleRightClick && props.handleRightClick(event, record, index),
          onClick: (event) => props.handleRowClick && props.handleRowClick(event, record), // Handle row click
        };
      }}
      components={props?.components}
      pagination={
        !props.noPagination && {
          position: props.positionPagination,
          defaultPageSize: props.perPageOptions ? props.perPageOptions : ITEMS_PER_PAGE, // Set the number of items per page
          showSizeChanger: true, // Allow the user to change the page size
          pageSizeOptions: props.pageSizeOptions ? props.pageSizeOptions : PAGE_SIZE, // Define the available page sizes
          total: props.total,
        }
      }
      tableLayout={props.tableLayout}
      scroll={props.scroll ? { x: '100%', y: '55.2vh' } : undefined}
      onChange={(pagination, filters, sorter) => {
        props.handlePageChange(pagination.current, pagination.pageSize, filters, sorter);
      }}
    />
  );
};

export default TableComponent;
